module.exports = __webpack_public_path__ + "media/images/activity-indicator-dark-ea51c9c36eb94e8acec93439ca0fe3a0.svg";